export const CLAIM_DETAILS_MODALS = {
    CONFIRM_REOPEN_CLAIM: 'CONFIRM_REOPEN_CLAIM',
    ACCEPT_CLAIM: 'ACCEPT_CLAIM',
    PRE_APPROVE_CLAIM: 'PRE_APPROVE_CLAIM',
    REJECT_CLAIM: 'REJECT_CLAIM',
    CLOSE_CLAIM: 'CLOSE_CLAIM',
    ADD_NOTE: 'ADD_NOTE',
};

export const TABS = {
    DETAILS: 'DETAILS',
    CLAIM_NOTES: 'CLAIM_NOTES',
    ORDER_NOTES: 'ORDER_NOTES',
    EXCEPTIONS: 'EXCEPTIONS',
};
